// extracted by mini-css-extract-plugin
module.exports = {"titleFav":"students_titleFav__1nnFo","Fav":"students_Fav__NBFe8"};